import { apiAction, API_ERROR, API_SUCCESS } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { openSnackbar } from "../dux/snackbar";
import { snackBarStatus } from "../helpers/constants";
import {
  getAllBookingsUrl,
  getUpdateBookingUrl,
  getCancelBookingUrl,
  getBookingStatisticsUrl,
  getUpdateSlotsUrl,
  getCreatePricingConfigUrl,
  // getUpdatePricingConfigUrl,
  // getAllPricingConfigsUrl,
  // getSpecialOffersUrl,
  // getDeletePricingConfigUrl,
  // getUpsertPricingUrl,
  getLocationSettingsUrl,
  // getUpdateInvoicePrefixUrl,
  // getUpdateFinancialYearUrl,
  // getGenerateInvoiceNumberUrl,
  getBlockDayUrl,
  getUnblockDayUrl,
  // getIsDayBlockedUrl,
} from "../helpers/apiEndPoints";
import { fetchBookingRecord } from "../dux/bookingRecords";

// Action types for admin operations
export const GET_ALL_BOOKINGS = "GET_ALL_BOOKINGS";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const UPDATE_BOOKING_DETAILS = "UPDATE_BOOKING_DETAILS";
export const CANCEL_BOOKING = "CANCEL_BOOKING";
export const GET_BOOKING_STATISTICS = "GET_BOOKING_STATISTICS";
export const UPDATE_SLOTS = "UPDATE_SLOTS";
export const CREATE_PRICING_CONFIG = "CREATE_PRICING_CONFIG";
export const UPDATE_PRICING_CONFIG = "UPDATE_PRICING_CONFIG";
export const GET_ALL_PRICING_CONFIGS = "GET_ALL_PRICING_CONFIGS";
export const GET_SPECIAL_OFFERS = "GET_SPECIAL_OFFERS";
export const DELETE_PRICING_CONFIG = "DELETE_PRICING_CONFIG";
export const UPSERT_PRICING = "UPSERT_PRICING";
export const GET_LOCATION_SETTINGS = "GET_LOCATION_SETTINGS";
export const UPDATE_INVOICE_PREFIX = "UPDATE_INVOICE_PREFIX";
export const UPDATE_FINANCIAL_YEAR = "UPDATE_FINANCIAL_YEAR";
export const GENERATE_INVOICE_NUMBER = "GENERATE_INVOICE_NUMBER";
export const BLOCK_DAY = "BLOCK_DAY";
export const UNBLOCK_DAY = "UNBLOCK_DAY";
export const IS_DAY_BLOCKED = "IS_DAY_BLOCKED";

// Action creators
export const updateBooking = (id, data) => ({
  type: UPDATE_BOOKING,
  payload: { id, data },
});

export const updateBookingDetails = (data, refresh) => ({
  type: UPDATE_BOOKING_DETAILS,
  payload: { data, refresh },
});

export const cancelBooking = (id, reason) => ({
  type: CANCEL_BOOKING,
  payload: { id, reason },
});

const admin =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    // Get all bookings (admin)
    if (action.type === GET_ALL_BOOKINGS) {
      next(apiCallStart({ api: "getAllBookings" }));
      next(
        apiAction({
          url: getAllBookingsUrl(),
          feature: GET_ALL_BOOKINGS,
          method: "GET",
          data: action.payload, // query parameters
        })
      );
    }

    if (action.type === `${GET_ALL_BOOKINGS} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "getAllBookings" }));
    }

    if (action.type === `${GET_ALL_BOOKINGS} ${API_ERROR}`) {
      next(apiCallComplete({ api: "getAllBookings" }));
      next(
        openSnackbar({
          message: "Failed to fetch bookings",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Update booking
    if (action.type === UPDATE_BOOKING) {
      const refresh = action.payload.refresh;
      next(apiCallStart({ api: "updateBooking" }));
      next(
        apiAction({
          url: getUpdateBookingUrl(action.payload.id),
          feature: UPDATE_BOOKING,
          method: "PUT",
          data: action.payload.data,
          meta: {
            refresh,
            onSuccess: () => {
              if (refresh) {
                dispatch(fetchBookingRecord(refresh));
              }
            },
          },
        })
      );
    }

    if (action.type === `${UPDATE_BOOKING} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "updateBooking" }));
      next(openSnackbar({ message: "Booking updated successfully" }));
    }

    if (action.type === `${UPDATE_BOOKING} ${API_ERROR}`) {
      next(apiCallComplete({ api: "updateBooking" }));
      next(
        openSnackbar({
          message: "Failed to update booking",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Update booking details (date/time changes)
    if (action.type === UPDATE_BOOKING_DETAILS) {
      next(apiCallStart({ api: "updateBookingDetails" }));
      next(
        apiAction({
          url: getUpdateBookingUrl(action.payload.data.booking_id),
          feature: UPDATE_BOOKING_DETAILS,
          method: "PUT",
          data: action.payload.data,
          meta: {
            onSuccess: () => {
              if (action.payload.refresh) {
                dispatch(fetchBookingRecord(action.payload.refresh));
              }
            },
          },
        })
      );
    }

    if (action.type === `${UPDATE_BOOKING_DETAILS} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "updateBookingDetails" }));
      next(openSnackbar({ message: "Booking details updated successfully" }));
    }

    if (action.type === `${UPDATE_BOOKING_DETAILS} ${API_ERROR}`) {
      next(apiCallComplete({ api: "updateBookingDetails" }));
      next(
        openSnackbar({
          message: "Failed to update booking details",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Cancel booking
    if (action.type === CANCEL_BOOKING) {
      next(apiCallStart({ api: "cancelBooking" }));
      next(
        apiAction({
          url: getCancelBookingUrl(action.payload.id),
          feature: CANCEL_BOOKING,
          method: "DELETE",
          data: { reason: action.payload.reason },
        })
      );
    }

    if (action.type === `${CANCEL_BOOKING} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "cancelBooking" }));
      next(openSnackbar({ message: "Booking cancelled successfully" }));
    }

    if (action.type === `${CANCEL_BOOKING} ${API_ERROR}`) {
      next(apiCallComplete({ api: "cancelBooking" }));
      next(
        openSnackbar({
          message: "Failed to cancel booking",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Get booking statistics
    if (action.type === GET_BOOKING_STATISTICS) {
      next(apiCallStart({ api: "getBookingStatistics" }));
      next(
        apiAction({
          url: getBookingStatisticsUrl(),
          feature: GET_BOOKING_STATISTICS,
          method: "GET",
        })
      );
    }

    if (action.type === `${GET_BOOKING_STATISTICS} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "getBookingStatistics" }));
    }

    if (action.type === `${GET_BOOKING_STATISTICS} ${API_ERROR}`) {
      next(apiCallComplete({ api: "getBookingStatistics" }));
      next(
        openSnackbar({
          message: "Failed to fetch statistics",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Update slots
    if (action.type === UPDATE_SLOTS) {
      next(apiCallStart({ api: "updateSlots" }));
      next(
        apiAction({
          url: getUpdateSlotsUrl(),
          feature: UPDATE_SLOTS,
          method: "POST",
          data: action.payload,
        })
      );
    }

    if (action.type === `${UPDATE_SLOTS} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "updateSlots" }));
      next(openSnackbar({ message: "Slots updated successfully" }));
    }

    if (action.type === `${UPDATE_SLOTS} ${API_ERROR}`) {
      next(apiCallComplete({ api: "updateSlots" }));
      next(
        openSnackbar({
          message: "Failed to update slots",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Pricing operations
    if (action.type === CREATE_PRICING_CONFIG) {
      next(apiCallStart({ api: "createPricingConfig" }));
      next(
        apiAction({
          url: getCreatePricingConfigUrl(),
          feature: CREATE_PRICING_CONFIG,
          method: "POST",
          data: action.payload,
        })
      );
    }

    if (action.type === `${CREATE_PRICING_CONFIG} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "createPricingConfig" }));
      next(openSnackbar({ message: "Pricing config created successfully" }));
    }

    if (action.type === `${CREATE_PRICING_CONFIG} ${API_ERROR}`) {
      next(apiCallComplete({ api: "createPricingConfig" }));
      next(
        openSnackbar({
          message: "Failed to create pricing config",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Settings operations
    if (action.type === GET_LOCATION_SETTINGS) {
      next(apiCallStart({ api: "getLocationSettings" }));
      next(
        apiAction({
          url: getLocationSettingsUrl(),
          feature: GET_LOCATION_SETTINGS,
          method: "GET",
        })
      );
    }

    if (action.type === `${GET_LOCATION_SETTINGS} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "getLocationSettings" }));
    }

    if (action.type === `${GET_LOCATION_SETTINGS} ${API_ERROR}`) {
      next(apiCallComplete({ api: "getLocationSettings" }));
      next(
        openSnackbar({
          message: "Failed to fetch location settings",
          status: snackBarStatus.ERROR,
        })
      );
    }

    // Holiday operations
    if (action.type === BLOCK_DAY) {
      next(apiCallStart({ api: "blockDay" }));
      next(
        apiAction({
          url: getBlockDayUrl(),
          feature: BLOCK_DAY,
          method: "POST",
          data: action.payload,
        })
      );
    }

    if (action.type === `${BLOCK_DAY} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "blockDay" }));
      next(openSnackbar({ message: "Day blocked successfully" }));
    }

    if (action.type === `${BLOCK_DAY} ${API_ERROR}`) {
      next(apiCallComplete({ api: "blockDay" }));
      next(
        openSnackbar({
          message: "Failed to block day",
          status: snackBarStatus.ERROR,
        })
      );
    }

    if (action.type === UNBLOCK_DAY) {
      next(apiCallStart({ api: "unblockDay" }));
      next(
        apiAction({
          url: getUnblockDayUrl(),
          feature: UNBLOCK_DAY,
          method: "POST",
          data: action.payload,
        })
      );
    }

    if (action.type === `${UNBLOCK_DAY} ${API_SUCCESS}`) {
      next(apiCallComplete({ api: "unblockDay" }));
      next(openSnackbar({ message: "Day unblocked successfully" }));
    }

    if (action.type === `${UNBLOCK_DAY} ${API_ERROR}`) {
      next(apiCallComplete({ api: "unblockDay" }));
      next(
        openSnackbar({
          message: "Failed to unblock day",
          status: snackBarStatus.ERROR,
        })
      );
    }
  };

export default admin;
